import { CourseType, LessonType } from '../../../types'
import { getCourseLessons } from './getCourseLessons'

export const getCourseCompletedLessons = (course?: CourseType, checkUserRecord?: boolean) => {
  if (!course?.modules) {
    return []
  }

  const allLessons = getCourseLessons(course)
  const completedLessons: LessonType[] = []

  // Loop through allLessons, adding completed lessons to completedLessons
  for (const lesson of allLessons) {
    if (lesson.isCompleted || (checkUserRecord && lesson.userLesson?.isCompleted)) {
      completedLessons.push(lesson)
    }
  }

  return completedLessons
}
